import { use_memoized_fn_default } from './chunk-24OWA2BQ.mjs';
import { useState } from 'react';

var useUpdate = () => {
  const [, setState] = useState({});
  return use_memoized_fn_default(() => {
    setState({});
  });
};
var use_update_default = useUpdate;

export { use_update_default };
